/** Canonical Influx monitor status: OK and UP are the same (healthy). */
export function normalizeInfluxStatus(status) {
  if (status == null || status === '') return null;
  const s = String(status).toUpperCase();
  if (s === 'OK') return 'UP';
  return s;
}

export function isInfluxUpStatus(status) {
  return normalizeInfluxStatus(status) === 'UP';
}

/** Normalize Influx monitor status for UI (API + socket). */
export function getInfluxMonitorStatus(target) {
  const raw = target?.last_status ?? target?.status;
  if (!raw) return 'UNKNOWN';
  return normalizeInfluxStatus(raw) || 'UNKNOWN';
}

export function isActiveInfluxTarget(target) {
  return target?.is_active !== false && target?.is_active !== 0 && target?.is_active !== '0';
}

export function influxStatusTagColor(status) {
  switch (normalizeInfluxStatus(status) || String(status || '').toUpperCase()) {
    case 'UP':
      return 'green';
    case 'ANOMALY':
      return 'orange';
    case 'DOWN':
    case 'ERROR':
      return 'red';
    case 'UNKNOWN':
      return 'default';
    default:
      return 'default';
  }
}

export function influxStatusLabel(status) {
  const s = normalizeInfluxStatus(status) || String(status || 'UNKNOWN').toUpperCase();
  if (s === 'UP') return 'OK';
  return s;
}

export function influxStatusIconType(status) {
  switch (normalizeInfluxStatus(status) || String(status || '').toUpperCase()) {
    case 'UP':
      return 'up';
    case 'ANOMALY':
      return 'anomaly';
    case 'DOWN':
    case 'ERROR':
      return 'down';
    default:
      return 'unknown';
  }
}
